/* FontAwesome */
import { 
  faHouse,

  faBoxesStacked,
  faBox,
  faSitemap,
  faFilter,
  faIndustry,
  faPercent,

  faCartShopping,

  faCogs,
  faUser,
  faUserGear,
  faServer,

  faBars,
  faList,
  faFileLines,
  faBookOpen,

  faSpider,
  faTicket,
  faChartColumn,

  
  IconDefinition,
} from '@fortawesome/free-solid-svg-icons'

interface Item {
  title: string
  icon: IconDefinition
}

interface ItemMixed {
  title: string
  icon: IconDefinition
  path?: string
  children?: MenuItem[]
}

export interface MenuItemLink extends Item {
  path: string
}

export interface MenuItemDropdown extends Item {
  children: MenuItem[]
}

type MenuItem = MenuItemLink | MenuItemDropdown

const menu: MenuItem[] = [

  {
    title: "Start",
    icon: faHouse,
    path: '',
  },
  

  /* +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */
  /* ++++++++++++++++++++++++ Auswertung +++++++++++++++++++++++++++ */
  {
    title: "Auswertung",
    icon: faChartColumn,
    children: [
      {
        title: "Idealo Auswertung",
        icon: faChartColumn,
        path: 'idealo-auswertung',
      },
      {
        title: "Idealo Arbeitsliste",
        icon: faList,
        path: 'idealo-arbeitsliste',
      },
      {
        title: "Referrer Traffic",
        icon: faChartColumn,
        path: 'idealo-traffic',
      },
      {
        title: "Umsatz Auswertung",
        icon: faChartColumn,
        path: 'umsatz-auswertung',
      },
      {
        title: "Web Vitals",
        icon: faChartColumn,
        path: 'web-vitals',
      },
      {
        title: "Produkt SEO Kontrolle",
        icon: faList,
        path: 'produkt-seo-kontrolle',
      },
      {
        title: "Content SEO/GEO/AIO",
        icon: faFileLines,
        path: 'content-seo-auswertung',
      },
    ],
  },

  /* +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */
  /* ++++++++++++++++++++++++ Produkte +++++++++++++++++++++++++++++ */
  {
    title: "Produkte",
    icon: faBoxesStacked,
    
    children: [
      {
        title: "Produkte",
        icon: faBox,
        path: 'produktfilter',
      },
      {
        title: "Produkt Importe",
        icon: faCogs,
        path: "produktaifilter",
      },
      {
        title: "ebay Vorlagen",
        icon: faFileLines,
        path: 'ebayvorlagen',
      },
      {
        title: "Idealo Einstellungen",
        icon: faCogs,
        path: 'idealo-einstellungen',
      },
      {
        title: "Kategorien",
        icon: faSitemap,
        path: 'kategoriefilter',
      },
      {
        title: "Filter",
        icon: faFilter,
        path: 'filterfilter',
      },
      {
        title: "Hersteller",
        icon: faIndustry,
        path: 'herstellerfilter',
      },
      {
        title: "Rabatte",
        icon: faPercent,
        path: 'rabattefilter',
      },
      {
        title: "Coupons",
        icon: faTicket,
        path: 'coupons',
      },
    ],
  },


  /* +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */
  /* +++++++++++++++++++++++ Bestellungen ++++++++++++++++++++++++++ */
  {
    title: "Bestellungen",
    icon: faCartShopping,
    path: 'bestellungen',
  },


  /* +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */
  /* +++++++++++++++++++++++++++ Menüs +++++++++++++++++++++++++++++ */
  {
    title: "Menüs",
    icon: faBars,
    
    children: [
      {
        title: "Menüs",
        icon: faList,
        path: 'menues',
      },
      {
        title: "Menü-Seiten",
        icon: faFileLines,
        path: 'menueseiten',
      },
    ],
  },

  /* +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */
  /* +++++++++++++++++++++++++ Magazine ++++++++++++++++++++++++++++ */
  {
    title: "Magazin",
    icon: faBookOpen,

    children: [
      {
        title: "Magazine",
        icon: faBookOpen,
        path: 'magazine',
      },
    ],
  },


  /* +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */
  /* +++++++++++++++++++++++ Preis Spion +++++++++++++++++++++++++++ */
  
  {
    title: "Crawler",
    icon: faSpider,

    children: [
      {
        title: "Übersicht",
        icon: faSpider,
        path: 'crawlers',
      },
    ],

  },
  
  /* +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */
  /* ++++++++++++++++++++++++++ System +++++++++++++++++++++++++++++ */
  {
    title: "System",
    icon: faCogs,

    children: [
      {
        title: "Mein Benutzerkonto",
        icon: faUser,
        path: 'benutzer',
      },
      {
        title: "Benutzerverwaltung",
        icon: faUserGear,
        path: 'benutzerverwaltung',
      },
      {
        title: "Server",
        icon: faServer,
        path: 'server',
      },
      {
        title: "eBay Konten",
        icon: faCogs,
        path: 'ebay-konten',
      },
      {
        title: 'Meta Kataloge',
        icon: faCogs,
        path: 'meta-kataloge',
      },
      {
        title: "Landingpages",
        icon: faFileLines,
        path: 'landingpages',
      },
    ],

  },


  /* +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */

]

export default (menu as ItemMixed[])
